<template>
  <div class="login">
    <v-row justify="space-around">
      <v-card elevation="8" id="login">
        <div class="login-title">
          <h1 style="font-weight: 500">Bienestar Total</h1>
        </div>
        <p class="login-txt">
          Por favor inicia sesión con tu cuenta y contraseña institucional. Recuerda que solo podrás entrar con cuentas corporativas (@uvmnet.edu, @mail.unitec.mx, @laureate.mx) con la excepción de los colegios. Para una mejor experiencia utiliza <strong>Firefox</strong> o <strong>Chrome</strong>. Si usas <strong>Safari</strong> da clic <span class="login-links" @click="openDialogSafari()">aquí</span>
        </p>
        <p class="login-txt mb-1">
          Si tienes algún problema con tu cuenta comunicate con <a href="mailto:mesadeayuda@laureate.mx" class="login-links">Mesa de ayuda</a>. O reinicia tu contraseña a travéz de <a href="https://passwordreset.microsoftonline.com" class="login-links" target="_blank">Office356</a>
        </p>
        <div class="login-options">
          <v-btn
            class="mb-3"
            outlined
            color="white"
            small
            :loading="loading"
            :disabled="loading"
            @click="login()"
          >
            Iniciar sesión <v-icon>mdi-microsoft-windows</v-icon>
          </v-btn>  
        </div>
      </v-card>
    </v-row>
    <!--DIALOG SAFARI-->
      <v-dialog
        :fullscreen="$vuetify.breakpoint.xsOnly"
        v-model="dialog_safari"
        max-width="50%"
        persistent
      >
        <v-card>
          <v-card-title class="headline">
            <span class="title-dialog">Safari</span>
          </v-card-title>
          <v-card-text>
            <p>Para el correcto funcionamiento en el navegador <strong>Safari</strong> vaya a <strong>Preferences -> Privacy</strong> y desabilite la opción <strong>Prevent cross-site tracking</strong> como se muestra en la imagen de abajo.</p>
            <img style="max-width: 100%" :src="require('@/assets/img/safari-help.jpg')">
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="#1976d2"
              text
              @click="dialog_safari = false"
            >
              Aceptar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
  </div>
</template>
<script>
  export default {
    name: 'Login',
    data(){
      return{
        dialog_safari: false,
        loading: false
      }
    },
    //
    methods: {
      openDialogSafari(){
        this.dialog_safari = true;
      },
      login(){
        this.loading = true;
        this.$msal.signIn();
      }
    },
    //
    created(){
      if(this.$msal.isAuthenticated()){
        this.$router.replace('home')
      }
    }
  }
</script>
<style lang="css" scoped>  
  @import '../assets/styles/login.css';
</style>